<template>
  <div class="add_notice">
    <div class="notice_title">
      <div class="label">标题</div>
      <div class="tit_cont">
        <input type="text" v-model="noticeTitle" maxlength="50" placeholder="请输入通知标题" />
      </div>
    </div>
    <div class="notice_cont">
      <div class="tit">公告内容</div>
      <div class="cont">
        <van-field
          class="text"
          v-model="noticeContent"
          accept
          maxlength="3000"
          type="textarea"
          placeholder="请输入公告内容"
        />
      </div>
    </div>
    <div class="upload_file">
      <div class="upload_tit">上传附件</div>
      <div class="file_item" v-for="item in fileResVOS" :key="item.id">
        <div class="file_msg">
          <img v-if="item.fileType ==='exl'" src="@/assets/appraise/ic_exl.png" alt />
          <img v-if="item.fileType ==='doc'" src="@/assets/appraise/ic_doc.png" alt />
          <img v-if="item.fileType ==='pdf'" src="@/assets/appraise/ic_pdf.png" alt />
          <p class="file_name">
            <span>{{item.fileName}}{{'.'+item.fileType}}</span>
          </p>
        </div>
        <div class="delImg" @click="del(item)">
          <img src="@/assets/appraise/delete.png" alt />
        </div>
      </div>
      <addBtn v-if="fileResVOS.length<10" :isShowSpan="true" :isGoAndroidandIOS="true" :needEmit="true" @fields="getFiles"></addBtn>
    </div>
    <div class="bot_btn">
      <van-button class="save_btn" :disabled="noticeTitle===''" @click="saveNotice" type="default">保存</van-button>
      <van-button class="public_btn" :disabled="noticeTitle===''" @click="unplicNotice" type="primary">发布</van-button>
    </div>
    <titleDialog
      v-if="showDialog"
      :title="dialogTitle"
      :cancelTxt="cancelBtn"
      :confirmTxt="confirmBtn"
      @confirm="confirm"
      @cancel="cancel"
    ></titleDialog>
    <confirmDialog
      v-if="showDialogSave"
      :title="'是否保存公告'"
      :content="'保存后，下次您可以继续编辑或发布公告'"
      :cancelTxt="'放弃'"
      :confirmTxt="'保存'"
      @confirm="confirmLeave"
      @cancel="cancelLeave"
    ></confirmDialog>
    <tipDialog :isShow="showTips" :content="requireCont" @closeModal="showTips=false"></tipDialog>
  </div>
</template>

<script>
import confirmDialog from "../components/confirmDialog.vue";
import titleDialog from "../components/titleDialog.vue";
import addBtn from "../appraiseNew/components/addBtn.vue";
import tipDialog from "../travelNegative/components/tipDialog";
import api from "@/service/modules/appraiseNew.js";
import icon from "@/assets/appraise/icon_ts_gx@3x.png";
export default {
  beforeRouteLeave(to, from, next){
    if(to.path==='/appraise/noticeManage'&&this.flag==='1') {
      this.showDialogSave = true;
      next(false)
    }else {
      next(true);
    }
  },
  components: {
    confirmDialog,
    titleDialog,
    addBtn,
    tipDialog
  },
  data() {
    return {
      showTips: false,
      requireCont: "",
      showDialog: false,
      dialogTitle: "",
      dialogContent: "",
      cancelBtn: "",
      confirmBtn: "",
      noticeTitle: "",
      noticeContent: "",
      fileResVOS: [],
      delItem: {},
      isSave: "1", // 1为保存，2为发布，3为删除
      fileList: [],
      showDialogSave: false,  // 离开编辑页面时触发
      flag: '1'   // 触发保存或者发布成功后，flag变为‘2’
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      if (this.$route.query.id) {
        this.queryDetail();
      }
    },
    // 获取详情
    queryDetail() {
      let params = {
        id: this.$route.query.id
      };
      api.getNoticeDesc(params).then(res => {
        if (res.ret === 0) {
          this.noticeTitle = res.data.noticeTitle;
          this.noticeContent = res.data.noticeContent;
          this.fileResVOS = res.data.fileResVOS||[];
        }
      });
    },
    // 上传附件回调
    getFiles(file) {
      this.fileResVOS.push(file[0]);
    },
    del(item) {
      this.dialogTitle = "是否确定删除附件";
      this.cancelBtn = "取消";
      this.confirmBtn = "删除";
      this.isSave = "3";
      this.delItem = item;
      this.showDialog = true;
    },
    // 保存公告
    saveNotice() {
      if (this.noticeTitle === "") {
        this.showTips = true;
        this.requireCont = "请输入“通知标题”";
        return;
      }
      this.isSave = "1";
      this.dialogTitle = "是否保存";
      this.dialogContent = "保存后，下次您可以继续编辑或发布公告";
      this.cancelBtn = "放弃";
      this.confirmBtn = "保存";
      this.showDialogSave = true;
    },
    // 发布公告
    unplicNotice() {
      if (this.noticeTitle === "") {
        this.requireCont = "请输入“通知标题”";
        this.showTips = true;
        return;
      } else if (this.noticeContent === "") {
        this.requireCont = "请输入“公告内容”";
        this.showTips = true;
        return;
      } else if (this.fileResVOS.length === 0) {
        this.requireCont = "请上传“相关附件”";
        this.showTips = true;
        return;
      }
      this.isSave = "2";
      this.dialogTitle = "是否确定发布公告";
      this.cancelBtn = "取消";
      this.confirmBtn = "发布";
      this.showDialog = true;
    },
    // 保存
    save() {
      let params = {
          id: this.$route.query.id,
          noticeTitle: this.noticeTitle,
          noticeContent: this.noticeContent,
          fileResVOS: this.fileResVOS
        };
      if(this.$route.query.id) {
        api.updateNotice(params).then(res => {
          if (res.ret === 0) {
            this.flag = '2';
            this.$router.replace("/appraise/noticeManage?type=1");
            this.$Toast({
              message: "保存成功",
              icon
            });
          }
        })
      } else {
        api.createNotice(params).then(res => {
          if (res.ret === 0) {
            this.flag = '2';
            this.$router.replace("/appraise/noticeManage?type=1");
            this.$Toast({
              message: "保存成功",
              icon
            });
          }
        });
      }
      
    },
    // 发布
    publish() {
      let params = {
        id: this.$route.query.id,
        noticeTitle: this.noticeTitle,
        noticeContent: this.noticeContent,
        fileResVOS: this.fileResVOS
      };
      if(this.$route.query.id) {
        api.updateNotice(params).then(res => {
          if (res.ret === 0) {
            api.submitNotice({id: this.$route.query.id}).then(res => {
              if (res.ret === 0) {
                this.flag = '2';
                this.$Toast({
                  message: "发布成功",
                  icon
                });
                setTimeout(() => {
                  this.$router.replace("/appraise/noticeManage?type=0");
                }, 2000);
              }
            });
          }
        });
      }else {
        api.createNotice(params).then(res => {
          if (res.ret === 0) {
            api.submitNotice({id: res.data}).then(res => {
              if (res.ret === 0) {
                this.flag = '2';
                this.$Toast({
                  message: "发布成功",
                  icon
                });
                setTimeout(() => {
                  this.$router.replace("/appraise/noticeManage?type=0");
                }, 2000);
              }
            });
          }
        });
      }
      
    },
    // 弹窗确认回调
    confirm() {
      if (this.isSave === "1") {
        this.save();
      } else if (this.isSave === "2") {
        this.publish();
      } else {
        let index = this.fileResVOS.indexOf(this.delItem);
        this.fileResVOS.splice(index, 1);
        this.$Toast({
              message: "删除成功",
              icon
            });
      }
      this.showDialog = false;
    },
    // 弹窗失败回调
    cancel() {
      this.showDialog = false;
    },
    // 编辑公告离开页面时保存编辑
    confirmLeave() {
      if (this.noticeTitle === "") {
        this.requireCont = "请输入“通知标题”";
        this.showDialogSave = false;
        this.showTips = true;
        return;
      }
      this.save();
    },
    // 编辑公告离开页面时放弃保存
    cancelLeave() {
      this.flag = '2';
      this.$router.replace("/appraise/noticeManage?type=1");
    }
  }
};
</script>

<style scoped lang="less">
.add_notice {
  padding: 0 12px 60px;
  width: 100%;
  height: 100%;
  position: relative;
}
.notice_title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 46px;
  border-bottom: 1px solid #ededed;
  .label {
    margin-right: 24px;
    font-size: 14px;
    color: #666;
    line-height: 46px;
    font-weight: 400;
  }
  .tit_cont {
    width: 299px;
    height: 45px;
    line-height: 45px;
    font-size: 14px;
  }
  .tit_cont input {
    width: 299px;
    height: 43px;
    line-height: 43px;
  }
  .tit_cont input::-webkit-input-placeholder {
    color: #ccc;
  }
}
.notice_cont {
  margin-top: 4px;
  .tit {
    padding: 12px 0;
    font-size: 14px;
    color: #666;
    font-weight: 400;
  }
  .tit::after {
    content: "*";
    color: red;
    font-size: 18px;
    height: 10px;
    width: 20px;
    height: 20px;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    line-height: 24px;
  }
  .cont .text {
    display: inline-block;
    padding: 12px;
    width: 100%;
    height: 209px;
    background-color: #f5f5f5;
    border-radius: 3px;
  }
  .cont .text /deep/ .van-cell__value .van-field__body textarea {
    height: 185px;
  }
  .cont
    .text
    /deep/
    .van-cell__value
    .van-field__body
    textarea::-webkit-input-placeholder {
    color: #999;
    font-size: 14px;
  }
}
.bot_btn {
  position: fixed;
  // position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 10px 15px;
  width: 100%;
  height: 60px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.03);
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  .van-button {
    width: 165px;
    height: 40px;
  }
  .save_btn {
    margin-right: 15px;
    font-size: 16px;
    color: #36b374;
    border: 1px solid #36b374;
  }
  .public_btn {
    font-size: 16px;
    background-color: #36b374;
  }
}
.van-dialog {
  background-color: red;
}
.upload_file {
  background-color: #fff;
  .upload_tit {
    padding: 16px 0;
    font-size: 14px;
    color: #666;
  }
  .upload_tit::after {
    content: "*";
    color: red;
    font-size: 18px;
    height: 10px;
    width: 20px;
    height: 20px;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    line-height: 24px;
  }
}
.file_item {
  display: flex;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 16px;
  .file_msg {
    flex: 1;
    display: flex;
    align-items: center;
  }
  .file_msg img {
    margin-right: 12px;
    width: 34px;
    height: 38px;
  }
  .file_msg p {
    font-size: 14px;
    color: #333;
    span {
      line-height: 20px;
      word-break: break-word;
    }
  }
  .file_size {
    font-size: 12px;
    color: #999;
  }
  .delImg {
    box-sizing: border-box;
    line-height: 38px;
    margin-left: 5px;
    margin-right: 10px;
  }
  .delImg img {
    width: 15px;
    height: 16px;
  }
}
</style>